module.exports = __webpack_public_path__ + "media/post-listing-cross-promotoe-ico-1@2x.424636c9.png";